"use client";

import { List } from "lucide-react";
import { useState } from "react";

export default function TableOfContents({ items }) {
  const [isExpanded, setIsExpanded] = useState(false);

  let mainCount = 0;
  let subCount = 0;

  // ✅ ADD THIS FUNCTION
  const handleClick = (e, id) => {
    e.preventDefault();

    const element = document.getElementById(id);
    if (!element) return;

    const offset = 80; // 👈 navbar height (adjust if needed)

    const top =
      element.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  return (
    <div className="border  rounded-md px-4 py-3 mb-5 border-l-2 border-l-black border-gray-200">
      <div className="flex items-center justify-between">
        <h2 className="text-xl text-gray-900">विषयसूची</h2>
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="p-2 hover:bg-gray-200 rounded transition-colors border border-gray-400"
        >
          <List size={16} />
        </button>
      </div>

      {isExpanded && (
        <ol className="mt-2 pb-2 space-y-1">
          {items.map((item) => {
            if (item.level === 2) {
              mainCount++;
              subCount = 0;
            }

            if (item.level === 3) {
              subCount++;
            }

            const number =
              item.level === 2 ? `${mainCount}.` : `${mainCount}.${subCount}`;

            return (
              <li
                key={item.id}
                className="text-gray-700 text-[15px] leading-[24px] hover:text-blue-600"
              >
                <a
                  href={`#${decodeURIComponent(item.id)}`}
                  onClick={(e) => handleClick(e, decodeURIComponent(item.id))} // ✅ yaha change
                  className={`flex items-start gap-1 ${
                    item.level === 3 ? "pl-5" : ""
                  }`}
                >
                  <span className="min-w-[16px]">{number}</span>
                  <span>{item.title}</span>
                </a>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
